const createKey = (planSer, fraction, groupIndex) =>
  `${planSer}-${fraction}-${groupIndex}`;

export default createKey;